import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect, useRef } from 'react';
import { Subject, Subscription } from 'rxjs';
var eventsSubscriber = function eventsSubscriber(action, setState) {
  switch (action.type) {
    case 'STOP':
      setState(true);
      break;
    case 'START':
      setState(false);
      break;
    default:
      throw new Error("Unknown event type: ".concat(action.type));
  }
};
var useLoaderState = function useLoaderState() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var _useState = useState(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    _isLoaded = _useState2[0],
    setLoaded = _useState2[1];
  var subject = useRef(null);
  useEffect(function () {
    subject.current = new Subject();
    var subscription = new Subscription();
    subscription.add(subject.current.subscribe(function (action) {
      return eventsSubscriber(action, setLoaded);
    }));
    return function () {
      return subscription.unsubscribe();
    };
  }, []);
  return {
    start: function start() {
      return subject.current.next({
        type: 'START'
      });
    },
    stop: function stop() {
      return subject.current.next({
        type: 'STOP'
      });
    },
    isLoaded: function isLoaded() {
      return _isLoaded;
    }
  };
};
export default useLoaderState;